import React, {
	Component
} from 'react';
import './SimPlanPromoSmallBox.css';
import Global from '../../Global';

class SimPlanPromoSmallBox extends Component {
    constructor(props) {
		super(props);

		this.state = {}
    }
    
    getDataPlan(boxDataPlanLabel){
        // var html = boxDataPlanLabel.map((item,index) =>(
        //     <div className="dataPlan" key={index}><a onClick={() => this.props.onSelect(item.planType, item.planId)}>{item.dataLabel}</a></div>
        // ));

        let lang = window.THREE_REACT_APP_GLOBAL.language;
        let html = boxDataPlanLabel.map((item,index) =>(
            <div className={"dataPlan" + (lang === "en" ? " dataPlanEN" : "")} key={index}>
                <a href={encodeURI(item.dataUrl)}>{item.dataLabel}</a>
            </div>
        ));

        return html;
    }

    planFiller = (simPlan) => {
        let lang = window.THREE_REACT_APP_GLOBAL.language;
        return(
            <div className="col-xs-12 box-div">
                <div className="small-promo-box-content">
                    <div className="boxDesc">{simPlan.boxDesc}</div>
                    <div className="boxDesc2Wrapper">
                        <div className="boxMonthDesc"> {simPlan.boxMonthDesc} </div>
                        <div className={"boxPrice" + (lang === "en" ? " boxPriceEN" : "")}> ${simPlan.boxPrice} </div>
                        <div className="boxMonthDesc2"> {simPlan.boxMonthDesc2} </div>
                    </div>
                    <div className="boxMonthDesc3">{simPlan.boxMonthDesc3}</div>
                    <div className="plan-desc-content">
                        <div className="boxDataDesc">{simPlan.boxDataDesc}</div>
                        {this.getDataPlan(simPlan.boxDataPlanLabel)}
                    </div>
                </div>
            </div>
        );
    }

    careFiller = (simPlan) => {
        return(
            <div className="col-xs-12 box-div">
                <div className="small-promo-box-content">
                    <div className="boxDesc">{simPlan.boxDesc}</div>
                    <div className="boxDesc2Wrapper">
                        <div className="boxMonthDesc"> {simPlan.boxMonthDesc} </div>
                    </div>
                </div>
            </div>
        );
    }

    generationLabelRender = (simPlan) => {
        let genStyle = {backgroundImage: "url('" + encodeURI(simPlan.generationBackground) + "')"};
        return(
            <React.Fragment>
                <div style={genStyle} className={"generationLabel " + (simPlan.generationLabel === '4.5G' ? 'lbl-45g' : 'lbl-4g')}>{simPlan.generationLabel}</div>
                <div className="boxTitle">{simPlan.boxTitle}</div>
            </React.Fragment>
        );
    }

    planDiv = (simPlan) => {
        let generationLabel = this.generationLabelRender(simPlan);
        let planContent = this.planFiller(simPlan);
        return(
            <div className="sim-plan-promo-small-box-container">
                <div className="row hidden-xs">
                    <div className="col-xs-12 box-div" style={{backgroundImage: "url(" + encodeURI(simPlan.boxImage) + ")"}}>
                        {generationLabel}
                    </div>
                    {planContent}
                </div>
                <div className="row visible-xs">
                    <div className="col-xs-12 box-div" style={{backgroundImage: "url(" + encodeURI(simPlan.boxImageMob) + ")"}}>
                        {generationLabel}
                    </div>
                    {planContent}
                </div>
            </div>
        );
    }

    careDiv = (simPlan) => {
        let generationLabel = this.generationLabelRender(simPlan);
        let planContent = this.careFiller(simPlan);
        return(
            <a href={simPlan.boxUrl} target={"blank"} className={"careAttr"}>
                <div className="sim-plan-promo-small-box-container">
                    <div className="row hidden-xs">
                        <div className="col-xs-12 box-div" style={{backgroundImage: "url(" + encodeURI(simPlan.boxImage) + ")"}}>
                            {generationLabel}
                        </div>
                        {planContent}
                    </div>
                    <div className="row visible-xs">
                        <div className="col-xs-12 box-div" style={{backgroundImage: "url(" + encodeURI(simPlan.boxImageMob) + ")"}}>
                            {generationLabel}
                        </div>
                        {planContent}
                    </div>
                </div>
            </a>
        );
    }

    render(){
        let simPlan = this.props.simPlanData;
        let planDiv = (simPlan.boxDetailType === "simplan") ? this.planDiv(simPlan) : this.careDiv(simPlan);
        return planDiv;
    }
}

export default SimPlanPromoSmallBox;